import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';
import { NgClass } from '@angular/common';



@Component({
    selector: 'app-checkbox',
    templateUrl: './checkbox.component.html',
    styleUrls: ['./checkbox.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [NgClass]
})

export class CheckboxComponent implements OnInit {


 @Input() customCBxDisabled = false;
 @Input() customCBxChecked: string;
 @Input() customCBxId = '';
 @Input() customCBxwrapperClass = '';
 @Input() customCBxlabelClass = '';
 @Input() customCBxInputClass = '';
 @Input() customCBxlabelText = '';
 @Output() changeEvent: EventEmitter<any> = new EventEmitter();

 customCheckBox = true;
checkedChanged = false;

 constructor() { }

  ngOnInit() {

  }
  customCheckboxChange(event) {
    this.customCBxChecked = event.target.checked;
    this.checkedChanged = true;
    this.changeEvent.emit(event);
  }
}
